/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject } from "@angular/core";
import { CanMatchFn, Router } from "@angular/router";
import { PermissionService } from "../shared/services/permission.service";

export const loginGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const token = localStorage.getItem("token");

  if (token) {
    const landing = inject(PermissionService).landingRoute();
    // With no permitted route, stay on the login page to avoid a redirect loop.
    if (landing !== "/login") {
      router.navigate([landing]);
      return false;
    }
  }
  return true;
};
